import React, { useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";

// common
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

// components
import ServicePop from "../terms/service";
import PrivacyPop from "../terms/privacy";
import MarketingPop from "../terms/marketing";

// assets
import icon_right_gray_18 from "bodycodi/cmap/app/svg/icon_right_gray_18.svg";

const sections = [
  {
    id: 1,
    name: "service",
    label: "서비스 이용약관",
    pageId: "SERVICE_DETAIL_POP",
    pageOpenContextName: "serviceDetailPop",
  },
  {
    id: 2,
    name: "privacy",
    label: "개인정보 취급방침",
    pageId: "PRIVACY_DETAIL_POP",
    pageOpenContextName: "privacyDetailPop",
  },
  {
    id: 3,
    name: "marketing",
    label: "마케팅 목적 개인정보 취급방침",
    pageId: "MARKETING_DETAIL_POP",
    pageOpenContextName: "marketingDetailPop",
  },
];

const TermsAndPolicy = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "TERMS_AND_POLICY_POP",
      open: { termsAndPolicyPop: false },
    });
  };

  const handleOpenNewPage = (pageId: string, pageOpenContextName: string) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: pageId,
      open: { [pageOpenContextName]: true },
    });
  };

  return (
    <CustomDialog open={state.termsAndPolicyPop} onClose={handleClose}>
      <PopupHeader title={"약관 및 정책"} onClickBack={handleClose} />
      <div className="sections">
        {sections.map((section) => (
          <div
            className="section"
            key={section.id}
            onClick={() => handleOpenNewPage(section.pageId, section.pageOpenContextName)}
          >
            <span>{section.label}</span>
            <img src={icon_right_gray_18} />
          </div>
        ))}
      </div>
      <ServicePop />
      <PrivacyPop />
      <MarketingPop />
    </CustomDialog>
  );
};

export default TermsAndPolicy;
